export default __webpack_public_path__ + "static/media/dna-bg.41857be7.png";